import {
  expensesOutOfPocketReportsAllRouteProps,
  expensesOutOfPocketReportsRouteProps,
  expensesOutOfPocketReportsYoursRouteProps,
  expensesYourReportsRouteProps,
  managerReviewReimbursementsRouteProps
} from 'src/navigation/routeProps'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import OutOfPocketReportsYourReducer, {
  Actions as ExpenseReportsFullPaginatedDataActions,
  ExpenseReportsFullPaginatedDataState,
  initialState as initialExpenseReportsFullPaginatedDataState,
} from 'src/redux/outOfPocketReportsYourFullPaginatedData.reducer'

export type SubmitterExpenseReportsState = {
  expenseReportsFullPaginatedData: ExpenseReportsFullPaginatedDataState
}

export const initialState: SubmitterExpenseReportsState = {
  expenseReportsFullPaginatedData: initialExpenseReportsFullPaginatedDataState,
}

export type Actions = ExpenseReportsFullPaginatedDataActions

const CoreSubmitterExpenseReportsReducer = (
  state = initialState,
  action: Actions,
): SubmitterExpenseReportsState => ({
  expenseReportsFullPaginatedData: OutOfPocketReportsYourReducer(
    state.expenseReportsFullPaginatedData,
    action as ExpenseReportsFullPaginatedDataActions,
  ),
})

const SubmitterExpenseReportsReducer = createBackgroundReducer(
  [
    expensesYourReportsRouteProps,
    expensesOutOfPocketReportsRouteProps,
    expensesOutOfPocketReportsAllRouteProps,
    expensesOutOfPocketReportsYoursRouteProps,
    managerReviewReimbursementsRouteProps,
  ],
  initialState,
  CoreSubmitterExpenseReportsReducer,
)

export default SubmitterExpenseReportsReducer
